<input #stageImageSelect type="file" accept="image/*" multiple />
<div #svgContainer class='stage-svg-container'
></div>
<div #stageSettings class="stage-settings"
  [class.open]="shouldShowPuzzleOverlayToggle">
  @if (shouldShowPuzzleOverlayToggle) {
    <div class="toggle-puzzle-overlay">
      @if (hasVisiblePuzzleOverlay) {
         <span (click)="showPuzzleOverlay(false)">
          <mat-icon svgIcon="eye-close"></mat-icon>
          {{ 'i18n.toggle.hidePuzzleOverlay' | translate }}
        </span>
      }
      @if (!hasVisiblePuzzleOverlay) {
        <span (click)="showPuzzleOverlay(true)">
          <mat-icon svgIcon="eye-open"></mat-icon>
          {{ 'i18n.toggle.showPuzzleOverlay' | translate }}
        </span>
      }
    </div>
  }
  @if (additionalInfoItemsDesignArea.length > 0) {
    <additional-info-items
      [additionalInfoItems]="additionalInfoItemsDesignArea">
    </additional-info-items>
  }
    <image-quality-rating>
    </image-quality-rating>
</div>
<div class="action-bars">
  <ng-template action-bars></ng-template>
</div>
<div class="stage-toolboxes" [class.open]="activeToolbox === 'ImageEditToolbox'">
  <div class="stage-toolbox-wrapper">
    <image-edit-toolbox></image-edit-toolbox>
  </div>
</div>
